import type { ComputedRef } from 'vue'
import type { LinkBreadcrumbItem } from '@shared/ui/menus'

import { resolveUrl } from '@shared/lib/url'
import { AppRoute } from '@shared/config'

import { CUSTOMER_TABS } from './customer-tabs'

interface CustomerDetailHeaderReturn {
  config: ComputedRef<LinkBreadcrumbItem[]>
}

/** General info is the customer page itself, so only the other tabs add a crumb after `Customer / {id}`. */
const CRUMB_TABS = CUSTOMER_TABS.filter(tab => tab.path !== AppRoute.CustomersShow)

export const useCustomerDetailHeader = (): CustomerDetailHeaderReturn => {
  const route = useRoute()
  const customerId = route.params.id as string

  const customerPath = resolveUrl(AppRoute.CustomersShow, { id: customerId }) ?? ''

  const config = computed<LinkBreadcrumbItem[]>(() => {
    const tabTitle = CRUMB_TABS.find(tab => resolveUrl(tab.path, { id: customerId }) === route.path)?.label ?? null
    const items: LinkBreadcrumbItem[] = [
      {
        id: 'customers',
        text: 'Customers',
        to: AppRoute.Customers,
        disabled: false,
      },
      {
        id: 'customer-detail',
        text: `Customer / ${customerId}`,
        to: customerPath,
        disabled: !tabTitle,
      },
    ]

    if (tabTitle) {
      items.push({
        id: 'customer-tab',
        text: tabTitle,
        to: null,
        disabled: true,
      })
    }

    return items
  })

  return {
    config,
  }
}
